import { render, staticRenderFns } from "./modal-social-create-group.vue?vue&type=template&id=72b4cb58&scoped=true&lang=pug"
import script from "./modal-social-create-group.js?vue&type=script&lang=js&external"
export * from "./modal-social-create-group.js?vue&type=script&lang=js&external"
import style0 from "./modal-social-create-group.vue?vue&type=style&index=0&id=72b4cb58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b4cb58",
  null
  
)

export default component.exports